import img from '../../../images/Baraa-Nazar.jpg';
import HeyamMsri from '../../../images/heyamMsri.jpg';
import Banel from '../../../images/banel_mikhael.jpg'

const employees = [
  {
    id: 1,
    name: 'Baraa',
    country: 'Iraq',
    Role: 'Front-end developer',
    profilePhoto: img,
  },
  {
    id: 2,
    name: 'Sakar',
    country: 'Kurdistan-Iraq',
    Role: 'Front-end developer',
    profilePhoto:
      'https://ca.slack-edge.com/T041DGW0Q64-U0419Q6PX3L-f7dbd03971e0-512',
  },
  {
    id: 3,
    name: 'Banel',
    country: 'Kurdistan-Iraq',
    Role: 'Front-end developer',
    profilePhoto:Banel,
  },
  {
    id: 4,
    name: 'Nma',
    country: 'Kurdistan-Iraq',
    Role: 'Front-end developer',
    profilePhoto:
      'https://ca.slack-edge.com/T041DGW0Q64-U040JJ7EA95-38abf5cbd2be-512',
  },
  {
    id: 5,
    name: 'Heyam',
    country: 'Lebanon',
    Role: 'Front-end developer',
    profilePhoto: HeyamMsri,
  },
];

export default employees;
